import { createSelector } from 'reselect';
import { RootState } from '../reducers';

export const selectSubscriptionDetails = createSelector(
  (state: RootState) => state.subscription,
  (subscription) => ({
    subscriptions: subscription.subscriptions,
    selectedSubscription: subscription.selectedSubscription,
    openSection: subscription.openSection,
    status: subscription.status,
    error: subscription.error,
    transactions: subscription.transactions,
    transactionsTotal: subscription.transactionsTotal,
    transactionsHasMore: subscription.transactionsHasMore,
    transactionsStatus: subscription.transactionsStatus,
    paymentSources: subscription.paymentSources,
    paymentSourcesStatus: subscription.paymentSourcesStatus,
  })
);
